/*
 * @Author: your name
 * @Date: 2021-11-10 23:27:16
 * @LastEditTime: 2022-05-26 17:27:17
 * @LastEditors: liuwujiang@easyretailpro.com liuwujiang@easyretailpro.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\permission.js
 */
import router from './router'
import store from './store';
import alertService from '@/utils/alert-service'
import storage from '@/utils/storage-service'

const whiteList = ['/login-auth', '/login','/satisfaction','/satisfaction-choice','/satisfaction-entrance','/satisfaction-questionnaire','/satisfaction-basic-information']
router.beforeEach(async (to, from, next) => {
    alertService.loading()
    if(to)
    {
        setMeta(to.meta)
        if(hasLogin()) {
            store.dispatch('user/getUserInfo')
            next();
        }
        else{
            if(whiteList.indexOf(to.path) !== -1) {
                next()
            } else {
                next('/login-auth')
                // next(`/login?redirect=${to.path}`)
            }
        }
    }
    else{
        console.error("跳转页面地址未空，无法跳转！")
        next('/')
    }
})
router.afterEach(async (to)=>{
    store.state.rights = to.meta.functions;
    alertService.loadingClose()//清除加载效果
})

/**
 * meta属性设置
 */
const setMeta = function(meta) {
    if(meta)
    {
        let navbar = meta.navbar
        let tabbar = meta.tabbar
        if(navbar) {
            store.dispatch('SetNavbar', { isShow: navbar.isShow, title: meta.title, isBack: navbar.isBack })
        }else
        {
            store.dispatch('SetNavbar', { isShow: false })
        }
        
        if(tabbar) {
            store.dispatch('SetTabbar', { isShow: tabbar.isShow, active: tabbar.active })
        }else
        {
            store.dispatch('SetTabbar', { isShow: false })
        }
    }
}

const hasLogin = function() {
    if(storage.get("token")) return true
    // let userInfo = this.$store.state.user.userInfo
    // if(userInfo) return true
    return false
}

/**
 * 路由校验
 */
// const authRoute = function() {
//     return new Promise((resolve, reject)=> {
//         // //先判断to路由是否需要权限
//         // if(to.meta.functions.length>0&&to.meta.functions!=="")
//         // {
//         //     let userFunctions = util.session("user").Rights;
//         //     let hasMenuItem = userFunctions.filter(func=>func==to.meta.functions)[0];
//         //     if(!hasMenuItem)
//         //     {
//         //         next(`/404`);
//         //     }
//         // }
//     })
// }